import { useState } from "react";

const faqs = [
  {
    q: "小猴看番线路卡顿怎么办？",
    a: "在播放页面点击播放器下方的\"线路切换\"按钮，选择备用线路即可秒级切换。小猴看番聚合了多个播放源，遇到某一线路卡顿时，其他备用线路通常依然流畅，无需退出页面。",
  },
  {
    q: "多源播放的自动选源是怎么工作的？",
    a: "播放开始时，系统会自动探测各个线路的可用性和响应速度，优先选择当前最稳定的播放源加载。如果后续某条线路延迟升高，也会在不打扰观看的前提下自动切至更优线路。",
  },
  {
    q: "切换备用线路会打断我当前的观看进度吗？",
    a: "不会。小猴看番会自动记忆每一集的播放进度，切换线路后会自动从原进度继续播放，无需手动拖动，真正做到秒切不断档。",
  },
  {
    q: "线路切换支持哪些清晰度？",
    a: "每条线路都会尽量提供多种清晰度选项。如果当前线路清晰度不理想，可以切换到备用线路，通常能获得更清晰的画质或更稳定的码率。",
  },
  {
    q: "为什么有时需要手动切换线路？",
    a: "自动选源会优先保证稳定播放，但不同网络环境对线路的友好程度不同。如果你感觉画面偏卡，可以手动试一下备用线路，找到最适合你当前网络的来源。",
  },
  {
    q: "多源播放会自动消耗更多流量吗？",
    a: "不会。自动选源只是选择最优播放源，同一时间只会播放一个来源，不会额外叠加流量。切换线路也只会加载当前选中的那一路源。",
  },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-secondary-100 px-4 py-1 text-sm font-medium text-secondary-900">
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
            关于线路切换与多源播放，你想知道的都在这里
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                >
                  <h3 className="text-sm font-medium text-foreground-950 md:text-base">
                    {f.q}
                  </h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <p className="border-t border-background-200 px-4 py-4 text-sm leading-relaxed text-foreground-700 md:px-5">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}